module.exports = __webpack_public_path__ + "static/img/bg-career-ability.202b011a.jpg";